<script>
  import ProgramGeneral from '../../../programs/components/forms/program.general';
  import ProgramPartner from '../../../programs/components/forms/program.partner';
  import ProgramDetails from '../../../programs/components/forms/program.details';
  import ProgramOther from '../../../programs/components/forms/program.other';

  export let value;
  let program = value.program;
</script>

<ProgramGeneral readonly="{true}" bind:value="{program}"></ProgramGeneral>
<ProgramPartner readonly="{true}" bind:value="{program}"></ProgramPartner>
<ProgramDetails readonly="{true}" bind:value="{program}"></ProgramDetails>
<ProgramOther readonly="{true}" bind:value="{program}"></ProgramOther>
